import * as types from './types';

import { createToast, toastType } from '../../../common/ToastHelper';

export const getTeachersAction = site => {
  return (dispatch, getState, MPWWebApi) => {
    dispatch(loadingFieldsAction(true));
    MPWWebApi.getGeneric(`student/teacher/${site}`)
      .then(response => {
        dispatch({
          type: types.GET_TEACHERS,
          payload: response,
        });
        dispatch(loadingFieldsAction(false));
      })
      .catch(error => {
        dispatch({
          type: types.GET_TEACHERS_ERROR,
          payload: error.response,
        });
        dispatch(loadingFieldsAction(false));
      });
  };
};

export const getTeachersReportAction = data => {
  return (dispatch, getState, MPWWebApi) => {
    dispatch(loadingReportAction(true));
    MPWWebApi.postGenericInsertUpdate('reports/teacherrolls', data)
      .then(response => {
        dispatch({
          type: types.GET_TEACHERS_REPORT,
          payload: response,
        });
        dispatch(loadingReportAction(false));
        if (response.data.Data === '') {
          createToast(toastType.info, 'Results', 'No data found!', true);
        }
      })
      .catch(error => {
        dispatch({
          type: types.GET_TEACHERS_REPORT_ERROR,
          payload: error.response,
        });
        dispatch(loadingReportAction(false));
        if (error.response.data.Errors[0].Title === null) {
          createToast(toastType.error, 'Error', 'Unable to view report', true);
        } else {
          createToast(
            toastType.error,
            error.response.data.Errors[0].Title,
            error.response.data.Errors[0].Message,
            true
          );
        }
      });
  };
};

export const loadingReportAction = status => {
  return {
    type: types.TEACHER_REPORT_LOAD,
    payload: status,
  };
};

export const loadingFieldsAction = status => {
  return {
    type: types.TEACHERS_LOAD,
    payload: status,
  };
};

export const clearReportDataAction = () => {
  return {
    type: types.CLEAR_REPORT_DATA,
  };
};



// WEBPACK FOOTER //
// ./src/pages/teacherrolls/state/actions.js